import { ISuggestionItem } from 'telia-front-react';

import { Address } from '../../../../stores/models/Address';

export const mapAddressesToAutocompleteItems = (addressList: Address[], addressText: string): ISuggestionItem[] => {
  return addressList.map((address: Address) => ({
    id: address.registryId.toString(),
    url: '#',
    label: address.fullAddressWithoutRoomName,
    isActive: address.fullAddressWithoutRoomName === addressText
  }));
};

export const sortAndMapRoomsToSuggestionItems = (rooms: string[]): ISuggestionItem[] => {
  return !rooms
    ? []
    : rooms
        .sort((a: any, b: any) => parseInt(a, 10) - parseInt(b, 10))
        .map((room: string, index) => ({
          id: `room-suggestion-${index}`,
          label: room,
          url: '#'
        }));
};
